export default "__VITE_ASSET__DxMQ7mW9__"